/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-body[_ngcontent-%COMP%]{background-color:#efefef}\n/*# sourceMappingURL=history-modal.component.css.map*/"];
export { styles as styles };
